export class Pubsub {
    obj: { [key: string]: Function[] } = {};

    listen(key: string, callback: Function) {
        this.obj[key] = this.obj?.[key] || [];
        this.obj[key].push(callback);

        const that = this;
        return function unListen() {
            that.obj[key] = (that.obj[key] || []).filter((fun) => fun !== callback);
        };
    }

    publish(key: string, value: any) {
        const funs = this.obj[key] || [];
        funs.forEach((callback) => callback(value));
    }
}
